<template>
	<div>
		<v-autocomplete
			:class="dense ? 'grv-input-dense' : 'grv-input'"
			class="chiped-input"
			:menu-props="{contentClass: 'grv-menu'}"
			:rules="rules"
			@update:error="errored = $event"
			:value="value"
			clearable
			:items="items"
			:loading="loading"
			item-text="name"
			item-value="code"
			:search-input.sync="search"
			:multiple="multiple"
			:readonly="readonly"
			auto-select-first
			:dense="dense"
			:name="param.name"
			no-filter
			hide-no-data
			chips
			:small-chips="dense"
			:deletable-chips="!readonly"
			placeholder="Rechercher un ayant-droit"
			@change="$emit('update:value', $event)">

			<template v-slot:label>
				<Label :param="param"></Label>
			</template>

			<template v-slot:item="{ tile, item }">
				<v-list-tile-avatar>
					<v-icon v-if="tile.props.value" color="primary">check_box</v-icon>
					<v-icon v-else>check_box_outline_blank</v-icon>
				</v-list-tile-avatar>
				<v-list-tile-content :title="`${item.code} | ${item.name}`">
					<v-list-tile-title>
						{{ item.name }}
					</v-list-tile-title>
					<v-list-tile-sub-title class="font-italic caption">
						{{ item.code }}
					</v-list-tile-sub-title>
				</v-list-tile-content>
				<v-list-tile-action>
					<v-btn
						flat icon
						:title="`copier le code client ${item.code}`"
						@click.stop="copyOwnerCode(item.code)">
						<v-icon small>content_copy</v-icon>
					</v-btn>
				</v-list-tile-action>
			</template>

			<template v-slot:append>
				<v-btn
					v-if="value"
					small flat icon
					class="ma-0"
					:title="`copier le code client ${value}`"
					@click.stop="copyOwnerCode(value)">
					<v-icon small>content_copy</v-icon>
				</v-btn>
			</template>
		</v-autocomplete>

		<Hint :param="param" :errored="errored"></Hint>
	</div>
</template>

<script>
import { debounce } from 'debounce'
import Label from '@/components/fields/label.vue'
import Hint from '@/components/fields/hint.vue'
export default {
	props: [
		'param',
		'value',
		'readonly',
		'dense'
	],
	components: {
		Label,
		Hint
	},
	data () {
		return {
			rules: [],
			errored: false,
			items: [],
			search: null,
			loading: false
		}
	},
	computed: {
		multiple () {
			return this.param.type.indexOf('multi-ownerid') === 0
		}
	},
	watch: {
		search (val) {
			if (val) {
				this.ownersSearch(val, null)
			}
		},
		value (val) {
			if (Array.isArray(val)) {
				let needGetOwners = false
				val.map(code => {
					if (this.code.indexOf(name) === -1) needGetOwners = true
				})
				if (needGetOwners) this.searchOwners(null, val)
			} else {
				if (val && this.code.indexOf(val) === -1) this.searchOwners(null, val)
			}
		}
	},
	methods: {
		copyOwnerCode (ownerCode) {
			this.$grv_clipboard.copyToClipboard(ownerCode)
			this.$EventDialer(
				'success',
				false,
				'Copié dans le presse-papier',
				ownerCode,
				2000
			)
		},
		ownersSearch: debounce(function (search, code) {
			if (!search && !code) return
			if (this.loading) return
			this.searchOwners(search, code)
		}, 100),
		searchOwners (search, code) {
			this.loading = true
			this.$EsMaestro.owner_search(search, code)
				.then(owners => {
					if (Array.isArray(this.value)) {
						this.items = this.items.filter(item => {
							return this.value.indexOf(item.id) > -1
						})
					} else {
						this.items = this.items.filter(item => {
							return this.value === item.id
						})
					}
					owners.map(item => {
						this.items.push(item)
					})
				})
				.catch(err => {
					console.log(err)
				})
				.finally(() => (this.loading = false))
		},
		requiredCheck (value) {
			if (value === '') return 'Requis'
			if (value === null) return 'Requis'
			if (value === undefined) return 'Requis'
			if (Array.isArray(value)) {
				if (value.length === 0) return 'Requis'
			}
			return true
		}
	},
	mounted () {
		if (!this.param) return
		if (this.param.required || this.param.required === undefined) {
			this.rules.push(this.requiredCheck)
		}
		if (this.value) this.searchOwners(null, this.value)
	}
}
</script>



// WEBPACK FOOTER //
// src/components/fields/ownerid.vue